import styled, { css } from 'styled-components'

type AddonPosition = 'before' | 'after'

export const AddonButtonContainer = styled.div<{ position: AddonPosition }>`
  height: 100%;
  min-width: 4rem;

  & > * {
    height: 100%;
    max-height: 100%;
    min-width: 4rem;
    ${(p) =>
      p.position === 'before'
        ? css`
            border-radius: 4px 0 0 4px;
            border-right: none;
          `
        : css`
            border-radius: 0 4px 4px 0;
            border-left: none;
          `}
  }

  & button {
    height: 100%;
    max-height: 100%;
    min-width: 100%;
    ${(p) =>
      p.position === 'before'
        ? css`
            border-radius: 4px 0 0 4px;
            border-right: none;
          `
        : css`
            border-radius: 0 4px 4px 0;
            border-left: none;
          `}
  }
`

export default AddonButtonContainer
